import {LightboxType} from "./options";

const actions = {
    LIGHTBOX_OPEN: 'LIGHTBOX_OPEN',
    LIGHTBOX_CLOSE: 'LIGHTBOX_CLOSE',
    LIGHTBOX_SET_CURRENT_INDEX: 'LIGHTBOX_SET_CURRENT_INDEX',

    LIGHTBOX_SET_FILES: 'LIGHTBOX_SET_FILES',
    LIGHTBOX_RESET: 'LIGHTBOX_RESET',

    /**
     *
     * @param {number} currentIndex - 0-based index of where the current page's view is (ie: in panelOther FileUploaderListManager)
     * @param {import("../../components/FileUploaderListManager/components/FileUploaderAndListV2/components/FilesList/useLightboxHandler").File[]} files
     * @param {LightboxType} lightboxType
     * @returns
     */
    open: (currentIndex = 0, files = [], lightboxType = null) => ({
        type: actions.LIGHTBOX_OPEN,
        lightboxType,
        currentIndex,
        files,
    }),

    openForPdfPreview: (transactionType, request = {}) => ({
        type: actions.LIGHTBOX_OPEN,
        lightboxType: LightboxType.pdf_preview,
        currentIndex: 0,
        files: [],
        transactionType,
        request,
    }),

    /**
     *
     * @param {number|null} fileId
     * @param {string|null} fileUrl
     * @returns
     */
    openForBukkuUpload: (readFileData, fileUrl, shouldReadFileId) => ({
        type: actions.LIGHTBOX_OPEN,
        lightboxType: LightboxType.bukku_upload,
        currentIndex: 0,
        files: [],
        readFileData,
        fileUrl,
        shouldReadFileId,
    }),

    close: () => ({
        type: actions.LIGHTBOX_CLOSE,
    }),
    setCurrentIndex: currentIndex => ({
        type: actions.LIGHTBOX_SET_CURRENT_INDEX,
        currentIndex,
    }),
    setFiles: files => ({
        type: actions.LIGHTBOX_SET_FILES,
        files,
    }),
    reset: () => ({
        type: actions.LIGHTBOX_RESET,
    }),

};
export default actions;
